import SectionMessage from '@atlaskit/section-message';
import React from 'react';
import t from 'modules/i18n/intl';
import styled from 'styled-components';
import { Font, Dimensions } from 'components/visuals';
import config from 'appconfig';
import Info from '@atlaskit/icon/glyph/info';
import { colors } from '@atlaskit/theme';

const InfoSectionMessage = styled.div`
  font-family: ${Font.displayFamily};
  margin: ${Dimensions.units(4)}px 0;

  & h1 {
    font-weight: 500;
  }
`;

const WarningSectionMessage = styled.div`
  font-family: ${Font.displayFamily};
  margin: ${Dimensions.units(2.5)}px 0;
`;

const infoIcon = () => <Info label="Info icon" primaryColor={colors.P400} />;

export const ServerAddonsEOLWarningMessage = () => {
  const learnMoreUrl = `${config.wacUrl}/migration/journey-to-cloud`;

  const text = t('eol.server-addons.warning.message.text');

  const link = t('eol.server-addons.warning.message.link');

  return (
    <WarningSectionMessage>
      <SectionMessage appearance="warning">
        {text}
        &nbsp;
        <a target="_blank" rel="noopener noreferrer" href={learnMoreUrl}>
          {link}
        </a>
      </SectionMessage>
    </WarningSectionMessage>
  );
};

export const DataCenterEOLSectionMessage = () => {
  const eolTitle = t('eol.dc.banner.title');
  const eolDescription = t('eol.dc.banner.text');
  const eolLearnMoreText = t('eol.dc.banner.link');
  const eolLearnMoreUrl = config.migrationLink;

  return (
    <InfoSectionMessage>
      <SectionMessage appearance="discovery" icon={infoIcon} title={eolTitle as string}>
        {eolDescription}
        &nbsp;
        <a target="_blank" rel="noopener noreferrer" href={eolLearnMoreUrl}>
          {eolLearnMoreText}
        </a>
      </SectionMessage>
    </InfoSectionMessage>
  );
};

export default DataCenterEOLSectionMessage;
